<template>
  <div
    ref="sectionRef"
    class="w-full overflow-hidden lg:w-[calc(100vw-35%)] lg:pr-8 2xl:w-[calc(100vw-30%)] 2xl:pr-[400px] hd:w-[calc(100vw-35%)] hd:pr-[20vw]"
  >
    <Transition name="fade" class="delay-600">
      <Swiper
        v-if="data"
        :modules="modules"
        class="slider featured-project-cards relative"
        :slides-per-view="1"
        :space-between="8"
        :speed="500"
        :lazy-preload-prev-next="1"
        :breakpoints="{
          1024: {
            slidesPerView: 'auto',
            allowTouchMove: false
          }
        }"
      >
        <SwiperSlide v-for="(item, idx) in data" :key="idx" class="lg:max-w-[572px]">
          <Image
            v-if="item.video?.thumbnail"
            class="aspect-video object-cover"
            :src="
              item.video?.thumbnail
                ? item.video?.thumbnail.responsiveImage?.src
                : item.video?.thumbnail.url
            "
            :srcset="
              item.video?.thumbnail.responsiveImage
                ? item.video?.thumbnail.responsiveImage?.webpSrcSet
                : undefined
            "
            :width="
              item.video?.thumbnail.responsiveImage
                ? item.video?.thumbnail.responsiveImage?.width
                : (item.video?.thumbnail.width ?? 20)
            "
            :height="
              item.video?.thumbnail.responsiveImage
                ? item.video?.thumbnail.responsiveImage?.height
                : (item.video?.thumbnail.height ?? 20)
            "
            :alt="item.video?.thumbnail?.alt ?? ''"
          />
          <span
            class="relative mt-2 inline-flex w-full justify-between text-sm uppercase text-black"
          >
            <NuxtLink
              v-if="item.title"
              :to="useLocalePathByType(item._modelApiKey, (item.slug as string) ?? undefined)"
            >
              {{ item.title }}
            </NuxtLink>
            <HyperLink
              class="whitespace-nowrap uppercase"
              :to="useLocalePathByType(item._modelApiKey, (item.slug as string) ?? undefined)"
            />
          </span>
        </SwiperSlide>
        <SwiperCursors decreased-height />
      </Swiper>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { Parallax, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { ProjectRecord } from '~/types/datocms'

import 'swiper/css'

const modules = [Parallax, A11y]

defineProps({
  data: {
    type: Array as PropType<ProjectRecord[]>,
    default: () => []
  }
})
</script>

<style lang="postcss">
.featured-project-cards {
  @apply container !overflow-visible lg:!max-w-none lg:!px-0;

  .swiper-wrapper {
    @apply box-border transform-gpu items-stretch !px-0 lg:ease-in-out;
  }

  .swiper-slide {
    @apply flex flex-col justify-end transition-all duration-300;
  }
}
</style>
